<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="'Manage Roles'"></Teranet-PageTitle>
    <div *ngIf="roleModel" class="teranet-padding" fxFlex="100">
      <form [formGroup]="roleForm" #createform="ngForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="mat-elevation-z4">
          <div fxFlex="100">
            <div fxLayout="column" fxLayoutAlign="center stretch">
              <Teranet-ClientTitle [ClientTitle]="'Role'" [IconName]="'filter'"></Teranet-ClientTitle>
              <div *ngIf="hasError" class="alert alert-danger" role="alert">
                <div>
                  <fa-icon icon="times" id="errorIcon" class="fa-lg" matTooltipPosition="above"></fa-icon>
                  &nbsp;Your data could not be saved because error(s) were found
                </div>
                <div>
                  <ul>
                    <li *ngFor="let errorMessage of errorMessages">
                      {{ errorMessage }}  is required
                    </li>
                  </ul>
                </div>
              </div>
              <div fxLayout.xs="column" fxLayout="row wrap">
                <div class="form-group-flex-column">
                  <mat-label class="required-field-after">Generic Role</mat-label>
                  <mat-form-field appearance="outline">
                    <mat-select required formControlName="Generic Role"
                                [(ngModel)]="roleModel.genericRoleId" (selectionChange)="onRoleChange()"
                                placeholder="--Please Select--">
                      <mat-option *ngFor="let item of roleList" [value]="item.id">
                        {{ item.displayName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="roleForm.get('Generic Role').hasError('required')">
                      Generic Role is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="form-group-flex-column">
                  <mat-label class="required-field-after">Corporation</mat-label>
                  <mat-form-field appearance="outline">
                    <mat-select required formControlName="Client"
                                [(ngModel)]="roleModel.clientInfoId" (selectionChange)="onClientChange(true)" placeholder="--Please Select--">
                      <mat-option *ngFor="let clientinfo of clients"
                                  [value]="clientinfo.id">
                        {{ clientinfo.corporationName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="roleForm.get('Client').hasError('required')">
                      Corporation is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="form-group-flex-column">
                  <mat-label class="required-field-after">Role Name</mat-label>
                  <mat-form-field appearance="outline">
                    <input matInput data-lpignore="true" formControlName="Role Name"
                           [(ngModel)]="roleModel.displayName" required />
                    <mat-error *ngIf="roleForm.get('Role Name').hasError('required') || roleForm.get('Role Name').hasError('whitespace')">
                      Role name is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout.xs="column" fxLayout="row wrap">
                <div class="form-group-flex-column">
                  <mat-label class="required-field-after">Description</mat-label>
                  <mat-form-field class="mat-form-field" appearance="outline">
                    <textarea matInput
                              required
                              data-lpignore="true"
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="4"
                              cdkAutosizeMaxRows="4"
                              formControlName="Description"
                              [(ngModel)]="roleModel.description"></textarea>
                    <mat-error *ngIf="roleForm.get('Description').hasError('required') || roleForm.get('Description').hasError('whitespace')">
                      Description is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div *ngIf="roleModel.dashboardPages">
                <div fxLayout.xs="column" fxLayout="row wrap">
                  <h5 class="required-field-after">User Access</h5>
                </div>
                <div *ngIf="roleForm.get('User Access').hasError('required')" class="form-group-flex-column">
                  <mat-error>
                    At least one permission is required
                  </mat-error>
                </div>
                <mat-divider></mat-divider><br />
                <div fxLayout.xs="column" fxLayout="row wrap">
                  <div class="form-group-flex-column">
                    <kendo-treeview [nodes]="roleModel.dashboardPages" textField="displayName"
                                    kendoTreeViewFlatDataBinding idField="id" parentIdField="parentId"
                                    [filterable]="true" kendoTreeViewCheckable
                                    [(checkedKeys)]="checkedKeys" checkBy="id"
                                    [loadOnDemand]="false"
                                    kendoTreeViewDisable = "displayName"
                                    [disabledKeys]="disabledKeys"
                                    kendoTreeViewExpandable 
                                    (checkedChange)="onCheckedChange($event)">
                    </kendo-treeview>
                  </div>
                </div>
              </div>
              <div fxLayout="row wrap" fxLayoutAlign="end">
                <button mat-raised-button class="plain-button" type="button" (click)="onCancel()">Cancel</button>
                <button mat-raised-button class="theme-button" type="submit">Save</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
